function Honeypot() {
  return (
    <div className='sweet' inert>
      <label htmlFor='importantfax'>Fax</label>
      <input type='checkbox' id='importantfax' name='importantfax' value='1' tabIndex={-1} />
    </div>
  );
}

export default Honeypot;
